export default { sha: '3ce6c410a7fc265f5ed5cb912088b2746784b09f', buildNumber: 'undefined' }
